import {DOCUMENT, Inject, Injectable, Injector} from '@angular/core';
import {ContextServiceMap, SiteContextConfig, SiteContextParamsService} from '@spartacus/core';
import {UX_TYPE_CONTEXT_ID, UX_TYPE_DEFAULT} from "./aimo-ux-type.service";

@Injectable()
export class AimoSiteContextParamsService extends SiteContextParamsService {
    constructor(
        config: SiteContextConfig,
        injector: Injector,
        serviceMap: ContextServiceMap,
        @Inject(DOCUMENT) protected document: Document,
    ) {
        super(config, injector, serviceMap);
    }

    getParamValues(param: string): string[] {
        const url: string = this.document.defaultView.window.location.href;
        if (param == UX_TYPE_CONTEXT_ID && this.document.defaultView.window.location.pathname != '/fi/login/process') {
            return [url.split('/')[4]]; // accept all
        }
        return super.getParamValues(param);
    }

    getParamDefaultValue(param: string): string | undefined {
        if (param == UX_TYPE_CONTEXT_ID) {
            return UX_TYPE_DEFAULT;
        }
        return super.getParamDefaultValue(param);
    }
}
